import React from "react";
import { OtpTextBox } from "./index";
import {Typography} from "@one-thd/sui-atomic-components";

const OtpEmailView = (props) => {
  const {
    emailEditContext
  } = props;

  const {
    email
  } = emailEditContext;

  return (
    <div>
      <Typography>
        We sent a verification code to your email
      </Typography>
      <div className='sui-break-all'>
        <Typography weight='bold'>
          {email}
        </Typography>
      </div>
      <OtpTextBox {...props} />
    </div>
  );
};

export default OtpEmailView;
